import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/utils/axiosCatalog';

export const getSiriusProductHistory = createAsyncThunk('/GetSiriusProductHistory', async (arr) => {
  const response = await axios.get(`/GetSiriusProductHistory/${arr[0]}/${arr[1]}/${arr[2]}/${arr[3]}/${arr[4]}`);
  return response.data;
});


const productHistorySlice = createSlice({
  name: 'productHistory',
  initialState: {
    loading: '',
    error: '',
    productHistory: []
  },
  reducers: {
  },
  extraReducers: {
    [getSiriusProductHistory.pending]: (state) => {
      state.loading = 'Loading';
    },
    [getSiriusProductHistory.rejected]: (state, action) => {
      state.error = action.payload;
    },
    [getSiriusProductHistory.fulfilled]: (state, action) => {
      state.productHistory = action.payload;
      state.loading = 'Finished';
    }
  }
});

export const productHistoryActions = productHistorySlice.actions;

export default productHistorySlice;
